import { createHook, createStore } from 'react-sweet-state';

import { getConfig } from '@townsquare/config';

const initialState: { canInviteUserToSite: boolean; hasCheckedAccess: boolean } = {
	canInviteUserToSite: false,
	hasCheckedAccess: false,
};

const createTqlStore = createStore({
	initialState,
	actions: {
		checkAccessToInviteUserToSite:
			(cloudId: string) =>
			async ({ setState, getState }) => {
				if (!cloudId || getState().hasCheckedAccess) {
					return getState().canInviteUserToSite;
				}
				const canInviteUserToSite = await userHasAccessToInviteUserToSite(cloudId);
				setState({
					canInviteUserToSite,
					hasCheckedAccess: true,
				});
			},
	},
	name: 'invite-user-store',
});

export const useInviteUserStore = createHook(createTqlStore);

async function userHasAccessToInviteUserToSite(cloudId: string) {
	const response = await fetch(
		`${getConfig().invitationsServiceUrl}/capabilities?resource=ari:cloud:platform::site/${cloudId}`,
		{
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
			},
		},
	);

	if (response.ok) {
		const data = (await response.json()) as CapabiltiesResponse[];
		return data.some(userHasCapabilityToInviteUserToResource);
	}
}

type CapabiltiesResponse = {
	resourceARI: string;
	role: string;
	directInvite: {
		mode: 'ANYONE' | 'DOMAIN_RESTRICTED' | 'NONE';
		domains?: string[];
	};
	invitePendingApproval: {
		mode: 'ANYONE' | 'NONE';
	};
};

function userHasCapabilityToInviteUserToResource(capability: CapabiltiesResponse) {
	return capability.invitePendingApproval.mode === 'ANYONE' || capability.directInvite.mode === 'ANYONE';
}
